<template>
  <section class="login-page">
    <div class="login-panel">
      <h1 class="login-title">HW鸿韦科技</h1>
      <el-form :model="form" @submit.native.prevent="login">
        <el-form-item>
          <el-input v-model="form.username" prefix-icon="el-icon-user" placeholder="账号" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.password" prefix-icon="el-icon-lock" placeholder="密码" show-password />
        </el-form-item>
        <el-button type="primary" icon="el-icon-right" :loading="loading" style="width:100%" @click="login">登录</el-button>
      </el-form>
    </div>
    <a
      class="login-icp"
      href="https://beian.miit.gov.cn/"
      target="_blank"
      rel="noopener noreferrer"
    >
      沪ICP备2021003472号-3
    </a>
  </section>
</template>

<script>
import http from '../api'

export default {
  data() {
    return {
      loading: false,
      form: { username: '', password: '' }
    }
  },
  methods: {
    async login() {
      this.loading = true
      try {
        const data = await http.post('/admin/auth/login', this.form)
        localStorage.setItem('ANTI_ADMIN_TOKEN', data.token)
        this.$message.success('登录成功')
        this.$router.replace('/dashboard')
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
